module.exports = __webpack_public_path__ + "img/edge_activites_aviron.619dad2d.svg";